import { useMemo, useRef, useState } from "react";

export default function OtpInput({ onOtpChanged }) {
  const [number1, setNumber1] = useState();
  //   otp ? (otp.length > 0 ? otp.charAt(0) : "") : ""
  // );
  const [number2, setNumber2] = useState();
  //   otp ? (otp.length > 1 ? otp.charAt(1) : "") : ""
  // );
  const [number3, setNumber3] = useState();
  //   otp ? (otp.length > 2 ? otp.charAt(2) : "") : ""
  // );
  const [number4, setNumber4] = useState();
  //   otp ? (otp.length > 3 ? otp.charAt(3) : "") : ""
  // );

  const number1Ref = useRef();
  const number2Ref = useRef();
  const number3Ref = useRef();
  const number4Ref = useRef();

  const getOtp = (num1, num2, num3, num4) => {
    return (
      (num1 || num1 == 0 ? num1 : "").toString() +
      (num2 || num2 == 0 ? num2 : "").toString() +
      (num3 || num3 == 0 ? num3 : "").toString() +
      (num4 || num4 == 0 ? num4 : "").toString()
    );
  };

  return (
    <div className="space-x-2 md:space-x-4 self-center mt-3 flex flex-row w-full">
      <input
        className="px-3 py-2 bg-transparent text-white font-open-sans text-2xl outline-none border-b-[1px] border-gray-300 w-full flex-1 flex text-center"
        value={number1}
        ref={number1Ref}
        onChange={(e) => {
          if (e.target.value === "") {
            setNumber1();
          } else {
            setNumber1(e.target.value.charAt(e.target.value.length - 1));
            number2Ref.current.focus();
          }
          onOtpChanged(
            getOtp(
              e.target.value == "" ? null : e.target.value % 10,
              number2,
              number3,
              number4
            )
          );
        }}
        type="number"
        min={0}
        max={9}
        maxLength={1}
      />
      <input
        className="px-3 py-2 bg-transparent text-white font-open-sans text-2xl outline-none border-b-[1px] border-gray-300 w-full flex-1 flex text-center"
        onChange={(e) => {
          if (e.target.value === "") {
            setNumber2();
            number1Ref.current.focus();
          } else {
            setNumber2(e.target.value.charAt(e.target.value.length - 1));
            number3Ref.current.focus();
          }
          onOtpChanged(
            getOtp(
              number1,
              e.target.value == "" ? null : e.target.value % 10,
              number3,
              number4
            )
          );
        }}
        type="number"
        min={0}
        max={9}
        value={number2}
        ref={number2Ref}
      />
      <input
        className="px-3 py-2 bg-transparent text-white font-open-sans text-2xl outline-none border-b-[1px] border-gray-300 w-full flex-1 flex text-center"
        onChange={(e) => {
          if (e.target.value === "") {
            setNumber3();
            number2Ref.current.focus();
          } else {
            setNumber3(e.target.value.charAt(e.target.value.length - 1));
            number4Ref.current.focus();
          }
          onOtpChanged(
            getOtp(
              number1,
              number2,
              e.target.value == "" ? null : e.target.value % 10,
              number4
            )
          );
        }}
        type="number"
        min={0}
        max={9}
        value={number3}
        ref={number3Ref}
      />
      <input
        className="px-3 py-2 bg-transparent text-white font-open-sans text-2xl outline-none border-b-[1px] border-gray-300 w-full flex-1 flex text-center"
        onChange={(e) => {
          if (e.target.value === "") {
            setNumber4();
            number3Ref.current.focus();
          } else {
            setNumber4(e.target.value.charAt(e.target.value.length - 1));
          }
          onOtpChanged(
            getOtp(
              number1,
              number2,
              number3,
              e.target.value == "" ? null : e.target.value % 10
            )
          );
        }}
        type="number"
        min={0}
        max={9}
        value={number4}
        ref={number4Ref}
      />
    </div>
  );
}
